import { useAtom, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const fontSizeAtom = atomWithStorage<number>('RV_USER_FONTSIZE', 1);

export const useSetFontSize = () => useSetAtom(fontSizeAtom);
export const useFontSize = () => useAtom(fontSizeAtom)[0];
